import React from 'react';
import ReactDOM from 'react-dom';
import Reviews from './reviews/index';

const componentElm = typeof document !== 'undefined' && document.getElementById('Reviews-component');

if (componentElm) {
    const initialState = window.initialData.Reviews;

    ReactDOM.render(
        <Reviews {...initialState}/>,
        componentElm
    );
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/index.js